import React from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router';

import { useDeviceInfo, useSelector } from '~Hooks';
import Toast from './Toast';

const Wrapper = styled.div<{ top: string; right: string; bottom: string; isPhone?: boolean }>`
  display: flex;
  width: ${({ isPhone }) => (isPhone ? '100%' : 'auto')};
  position: fixed;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  z-index: 999;
  gap: 4px;
`;

const ToastWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

const Toasts = () => {
  const location = useLocation();
  const toasts = useSelector((state) => state.toasts);
  const deviceInfo = useDeviceInfo();

  let positionObj = { top: '16px', right: '16px', bottom: 'auto' };

  // Toasts need to clear the notch on phones
  if (deviceInfo?.isPhone) {
    positionObj = { top: '10%', right: 'auto', bottom: 'auto' };
  }

  // In tables view, position toasts at the bottom
  const isTables = location.pathname.includes('tables');
  if (location.pathname.includes('tables')) {
    positionObj = { top: 'auto', right: '415px', bottom: '70px' };
  }

  const isPOS = location.pathname.includes('pos');
  // In pos view, position toasts at the bottom
  if (isPOS) {
    positionObj = { top: 'auto', right: '343px', bottom: '78px' };
  }

  const hasBottomPlacement = isPOS || isTables;

  const reverseToasts = [...toasts].reverse();

  return (
    <Wrapper
      top={positionObj.top}
      right={positionObj.right}
      bottom={positionObj.bottom}
      isPhone={deviceInfo?.isPhone}>
      {reverseToasts.map((toast, index) => {
        const max = 24;
        const position = index * 8 > max ? max : index * 8;
        const scale = 1 - index * 0.05;

        return (
          <ToastWrapper
            key={'toast-wrapper-' + toast.id}
            style={{
              top: `${hasBottomPlacement ? 'auto' : position + 'px'}`, // Push up each toast by 2px
              bottom: `${hasBottomPlacement ? position + 'px' : 'auto'}`,
              transform: `scale(${scale})`, // Shrink the previous toasts gradually
              zIndex: 1000 - index, // Control the stacking order
            }}>
            <Toast key={toast.id} {...toast} />
          </ToastWrapper>
        );
      })}
    </Wrapper>
  );
};

export default Toasts;
